/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef, useEffect } from 'react'
import { useGLTF, useAnimations } from '@react-three/drei'

export default function Model({ ...props }) {
	const group = useRef()
	const { nodes, materials, animations } = useGLTF(
		'https://ipfs.gamedao.co/gateway/QmTNFjmnFaYFjYHAhopPqfXQ2sXnzbcSePtXhYrwUmuf5T'
	)
	const { actions } = useAnimations(animations, group)
	React.useEffect(() => {
		actions['Root|CINEMA_4D_Basis|Layer0'].play()
	})
	return (
		<group ref={group} {...props} dispose={null}>
			<group
				position={[0.01, 1.9, -0.01]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={0.01}
			>
				<primitive object={nodes.hip} />
				<skinnedMesh
					name="Mesh"
					geometry={nodes.Mesh.geometry}
					material={materials['Mat.1']}
					skeleton={nodes.Mesh.skeleton}
					morphTargetDictionary={nodes.Mesh.morphTargetDictionary}
					morphTargetInfluences={nodes.Mesh.morphTargetInfluences}
				/>
				<skinnedMesh
					name="Mesh_1"
					geometry={nodes.Mesh_1.geometry}
					material={materials['Mat.002']}
					skeleton={nodes.Mesh_1.skeleton}
					morphTargetDictionary={nodes.Mesh_1.morphTargetDictionary}
					morphTargetInfluences={nodes.Mesh_1.morphTargetInfluences}
				/>
				<skinnedMesh
					name="Mesh_2"
					geometry={nodes.Mesh_2.geometry}
					material={materials.schwarz}
					skeleton={nodes.Mesh_2.skeleton}
					morphTargetDictionary={nodes.Mesh_2.morphTargetDictionary}
					morphTargetInfluences={nodes.Mesh_2.morphTargetInfluences}
				/>
			</group>
			{/*<mesh geometry={nodes.Wall.geometry} material={materials['0x72_16x16DungeonTileset.v4']} />*/}
		</group>
	)
}

useGLTF.preload('/untitled.gltf')
